var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrfosWoName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 213 213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "gear",
    d: "M 95,1 C 94,1 92,2 92,4 L 88,16 76,20 66,10 62,10 c -6,3 -13,6 -19,11 l -1,3 3,13 -9,9 -13,-3 -3,1 C 15,50 12,57 9,63 l 0,4 10,10 -4,12 -12,4 c -2,0 -3,2 -3,3 l 0,21 c 0,2 1,3 3,4 l 12,3 4,13 -10,9 0,4 c 3,7 6,13 11,19 l 3,2 13,-4 9,9 -3,13 1,4 19,11 c 2,1 3,0 4,-1 l 10,-9 12,3 4,13 c 0,2 2,3 3,3 l 21,0 c 2,0 3,-1 4,-3 l 3,-13 c 5,0 9,-2 13,-3 l 9,9 c 1,1 3,2 4,1 l 19,-11 2,-4 -4,-13 c 4,-2 7,-5 9,-9 l 13,4 4,-2 11,-19 c 1,-1 0,-3 -1,-4 l -9,-9 c 1,-4 3,-8 3,-13 l 13,-3 c 2,-1 3,-2 3,-4 l 0,-21 c 0,-1 -1,-3 -3,-3 l -13,-4 -3,-12 9,-10 c 1,-1 2,-2 1,-4 l -11,-19 -4,-1 -13,3 -9,-9 4,-13 -2,-3 c -6,-5 -12,-8 -19,-11 l -4,0 -9,10 -13,-4 -3,-12 c -1,-2 -2,-3 -4,-3 z m 11,35 a 71,71 0 1 1 0,142 71,71 0 0 1 0,-142 z",
    id: "path4",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 71,76 8,0 0,67 -8,0 z m 9,0 7,0 0,67 -7,0 z m 8,8 0,7 23,0 0,52 8,0 0,-59 z m 32,0 0,59 7,0 0,-52 23,0 0,-7 z m -32,-1 0,-7 62,0 0,7",
    id: "path6",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrfosWoName);
export default __webpack_public_path__ + "static/media/orfos-wo-name.da4c645f9e37e4f1fe18593de9c8a7af.svg";
export { ForwardRef as ReactComponent };